import React, { Component, PropTypes } from 'react';
import { RaisedButton, FontIcon } from 'material-ui';
import SearchIcon from 'material-ui/svg-icons/action/search';
import SectionHeading from '../tc-ui/section-heading.jsx';

class ProfileCompleteSplash extends Component {

  goToUrl = (pageToGoTo) => {
    const { history } = this.props;
    history.push(pageToGoTo);
  }

  goToNewSystem = (pageToGoTo, search) => window.location = (`${
    process.env.NEW_SYSTEM_URL
  }${pageToGoTo}${
    search ? `${search}&` : '?'
  }jwt=${
    localStorage.getItem('jwt')
  }`)

  render() {
    const styles = {
      buttonFontIcon: {
        height: '100%',
        display: 'inline-block',
        verticalAlign: 'middle',
        float: 'left',
        paddingLeft: '12px',
        lineHeight: '36px',
      },
      canvasPaper: {
        width: '100%',
        padding: '20px',
        textAlign: 'center',
      },
      leftDiv: {
        width: '33%',
        display: 'inline-block',
        textAlign: 'center',
      },
      middleDiv: {
        width: '33%',
        display: 'inline-block',
        textAlign: 'center',
      },
      rightDiv: {
        width: '33%',
        display: 'inline-block',
        textAlign: 'center',
      },
      paper: {
        margin: '20px auto',
        height: '245px',
      },
      paperTitle: {
        borderBottom: '1px solid #efefef',
        backgroundColor: '#fbfbfb',
        padding: '15px',
        fontSize: '20px',
        fontWeight: '500',
      },
      paperBody: {
        margin: '20px 20px 24px 40px',
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
        minHeight: '90px',
      },
    };

    return (
      <div className="l-app-content">
      <div style={styles.canvasPaper}>

      <SectionHeading
        title={"Congratulations, your profile is complete!"}
        subtitle={"Here are a few ways we can help you:"}
        style={{ marginBottom: '96px' }}
      />

        <div style={styles.leftDiv}>
          <FontIcon className="tc-icon-person_add" color="#ff4081" style={{ fontSize: '128px' }} />
          <div style={{ marginTop: '10px' }}><span><b>ADD EXISTING PARTNERS</b></span></div>
          <div style={styles.paperBody}>
            {"Wouldn't it be nice if you had up-to-date contacts for all of your partners? Upload your partners."}
          </div>
          <RaisedButton
            onClick={() => this.goToNewSystem('/partner-management/import')}
            label="Add Partners"
            style={styles.button}
            primary
            labelStyle={{ fontWeight: 'bold' }}
          />
        </div>

        <div style={styles.middleDiv}>
          <SearchIcon color="#00bcd4" style={{ height: '128px', width: '128px' }}/>
          <div style={{ marginTop: '10px' }}><span><b>SEARCH FOR NEW PARTNERS</b></span></div>
          <div style={styles.paperBody}>
            {"Are you looking to find new suppliers to work with or agents to book with you? Start searching now."}
          </div>
          <RaisedButton
            onClick={() => this.goToUrl('/partner-finder/results')}
            label="Start Searching"
            style={styles.button}
            secondary
            labelStyle={{ fontWeight: 'bold' }}
          />
        </div>

        <div style={styles.rightDiv}>
          <FontIcon className="tc-icon-insert-drive-file" color="rgba(255, 183, 0, 0.87)" style={{ fontSize: '128px' }} />
          <div style={{ marginTop: '10px' }}><span><b>RECEIVE SUPPLIER RATES</b></span></div>
          <div style={styles.paperBody}>
            {"If you contract or book directly with your suppliers, go ahead and request their rates using our universal contract format."}
          </div>
          <RaisedButton
            onClick={() => this.goToNewSystem('/partner-management/send-assets', '?open_asset_type=requests')}
            label="REQUEST RATES"
            style={styles.button}
            backgroundColor="rgba(255, 183, 0, 0.87)"
            labelColor="#ffffff"
          />
        </div>

      </div>
      </div>
    );
  }
}

ProfileCompleteSplash.propTypes = {
  history: PropTypes.object,
};

export default ProfileCompleteSplash;



// WEBPACK FOOTER //
// ./src/app/components/splash-pages/contractor-profile-completeness-splash.jsx